module.exports = __webpack_public_path__ + "img/dielectric_window_set.67feca56.png";